class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.initMenuInteractions();
  }

  initMenuInteractions() {
    // Prevent the default summary click behavior
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    }

    // Handle toggle button clicks
    const toggleButton = this.querySelector('.header__menu-toggle');
    if (toggleButton) {
      toggleButton.addEventListener('click', this.onToggleClick.bind(this));
    }

    // Handle link clicks
    const menuLink = this.querySelector('.header__menu-link');
    if (menuLink) {
      menuLink.addEventListener('click', this.onLinkClick.bind(this));
    }
  }

  onSummaryClick(event) {
    // Prevent default details/summary behavior
    event.preventDefault();
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    // Toggle the details element
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (isOpen) {
      this.close();
    } else {
      this.mainDetailsToggle.setAttribute('open', '');
      const summaryElement = this.mainDetailsToggle.querySelector('summary');
      summaryElement.setAttribute('aria-expanded', 'true');

      // Trigger the onToggle method to handle positioning
      this.onToggle();
    }
  }

  onLinkClick(event) {
    // Allow normal navigation behavior for the link
    // This will navigate to the URL while the toggle button handles dropdown
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
